import { Fragment, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import compact from 'lodash/compact';
import get from 'lodash/get';
import map from 'lodash/map';
import split from 'lodash/split';
import { useFacilityMenuItems } from 'shared-feature-facility-menu';

import {
  useWebPunchSession,
  WEB_PUNCH_LINK,
} from '@sbv-clients/data-access-api';
import { useAuth } from '@sbv-clients/shared-feature-auth';
import { OverlayLoader } from '@sbv-clients/ui-shared';

const getPrefix = (pathname: string) => get(split(pathname, '/'), [1]);

const MENU_EXEMPT_PATH_PREFIXES = ['contact-us'];
const Body = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const pathname = location.pathname;
  const { allMenuItems = [], isLoading } = useFacilityMenuItems();
  const { isMobileSession, isLoading: isLoadingSession } = useWebPunchSession();
  const allowedPathNamePrefix = compact(
    map(allMenuItems, (item) => getPrefix(item.link ?? ''))
  );
  const currentPathNamePrefix = getPrefix(pathname);

  if (!isLoadingSession && isMobileSession) {
    if (currentPathNamePrefix !== getPrefix(WEB_PUNCH_LINK)) {
      return <Navigate to={WEB_PUNCH_LINK} />;
    }
    return <Fragment>{children}</Fragment>;
  }

  if (
    !isLoading &&
    currentPathNamePrefix &&
    !MENU_EXEMPT_PATH_PREFIXES.includes(currentPathNamePrefix) &&
    !allowedPathNamePrefix.includes(currentPathNamePrefix)
  ) {
    return <Navigate to="/" />;
  }
  return <Fragment>{children}</Fragment>;
};

const PrivateRouteGuard = ({ children }: PropsWithChildren) => {
  const { initialised, authenticated } = useAuth();

  if (!initialised) {
    return <OverlayLoader />;
  }

  if (initialised && !authenticated) {
    return <Navigate to="/auth/sign-in" />;
  }

  return <Body>{children}</Body>;
};

export default PrivateRouteGuard;
